import { render, staticRenderFns } from "./realData.vue?vue&type=template&id=b2038f4a&scoped=true"
import script from "./realData.vue?vue&type=script&lang=js"
export * from "./realData.vue?vue&type=script&lang=js"
import style0 from "./realData.vue?vue&type=style&index=0&id=b2038f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2038f4a",
  null
  
)

export default component.exports